import { DateLayout, DateText } from "pages/home/components/DateSection/styled";

/**
 * 날짜 섹션
 */
export const DateSection = () => {
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  const date = currentDate.getDate();
  const todaysDate = `${month}월 ${date}일`;

  return (
    <DateLayout>
      <DateText style={{ textAlign: "right" }}>{todaysDate}</DateText>
    </DateLayout>
  );
};
